var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"btn btn-primary btn-xnax-login ",on:{"click":function($event){return _vm.DefaultLogin()}}},[_vm._v("Default Login")])])}
var staticRenderFns = []

export { render, staticRenderFns }